import { render, staticRenderFns } from "./detailFedEx.vue?vue&type=template&id=bc8b9a46&scoped=true"
import script from "./detailFedEx.vue?vue&type=script&lang=js"
export * from "./detailFedEx.vue?vue&type=script&lang=js"
import style0 from "./detailFedEx.vue?vue&type=style&index=0&id=bc8b9a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8b9a46",
  null
  
)

export default component.exports